<template>
  <div class="Subpage">
    <Bigmenu :NavStatus="Bignav" :Way="2" :ShowBackBtn="true" v-on:cellback="OpenStatus" style="z-index: 2"></Bigmenu>
    <div class="frame" style="z-index: -2"></div>
    <Container v-if="!Bignav" :Type="false" :ImgUrl="'b01.png'" :Container="Container"  style="z-index: -6"></Container>

  </div>
</template>

<script>
import Bigmenu from '@/components/Bigmenu.vue'
import Back from '@/components/Back.vue';
import Container from '@/components/Container.vue';
export default {
  name: 'About',
  data () {
    return {

      Bignav: false,
      Container:{
        title:'呼吸閘控放射治療',
        videosrc:'T01.mp4',
        list:[
          {
            body:"RPM 系統能讓臨床醫師根據病患的呼吸週期，建立腫瘤位置的關聯。此系統使用紅外線追蹤攝影機與反光標記衡量病患的呼吸模式與移動範圍，然後以波形顯示。系統可調控閾值，用以決定啟動及關閉治療射束的時機。"

          },
          {
            body:"RPM 系統可協助肺部、肝臟與胰臟的治療，而在乳房治療上，則有助於將心臟所接收的劑量降到最低。 系統會提供清晰影像以供計畫之用，由於與呼吸動作有關的偽影減少，臨床醫師便能看到更清楚的目標。<br><br>影片為應用在肺部之案例。"
          }
        ]
      }




    }
  },
  components: {
    Back,Container,Bigmenu
  },
  methods:{
    OpenStatus(v){
      this.Bignav = v.status
    }
  }
}
</script>
<style lang="scss" scoped>
  .Subpage{
    height: 100%;
    width: 100%;
  }
  .frame {

    position: absolute;
    background-image: url("../../assets/frame.png");
    background-position: center;
    height: 1080px;
    width: 1920px;
  }
</style>
